import { createRef, PureComponent } from 'react';
import classNames from 'classnames/bind';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import autoBind from 'react-autobind';
import cloneDeep from 'lodash-es/cloneDeep';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faXmark } from '@fortawesome/pro-light-svg-icons/faXmark';

import SearchbarInner from '../../SearchbarComponents/SearchbarInner';
import WatchlistNameActions from '../WatchlistNameActions';
import Preloader from '../../Preloader';
import WatchlistUpdateSuggestion from '../../SubscriptionsComponents/WatchlistUpdateSuggestion';
import withComponentName from '../../../decorators/withComponentName';

import loadable from '../../../utils/loadable';

import * as searchActions from '../../../actions/searchActions';
import * as watchlistActions from '../../../actions/watchlistActions';

import { SILVER } from '../../../data/permissions';

import Styles from './styles.module.scss';

const RemoveAllWatchlistsModal = loadable(() => import('../../Modals/RemoveAllWatchlistsModal'));

const cx = classNames.bind(Styles);

class WatchlistDropDown extends PureComponent {
  constructor(props) {
    super(props);
    autoBind(this);
    this.watchlistRemoveModal = null;
    this.dropDown = createRef();
    this.mounted = false;
    this.state = {
      openModal: false,
      scrolled: false,
    };
  }

  componentDidMount() {
    document.addEventListener('click', this.handleClickOutside);
    document.addEventListener('scroll', this.handleScroll);
    this.mounted = true;
  }

  componentWillUnmount() {
    document.removeEventListener('click', this.handleClickOutside);
    document.removeEventListener('scroll', this.handleScroll);
    this.mounted = false;
  }

  handleClickOutside(e) {
    const { dropDownOpen, actions } = this.props;
    setTimeout(() => {
      const warningWrapper = document.getElementsByClassName('topic_user_warning_modal')[0];
      if (
        e?.target.className === 'active-watchlist-name'
        || e?.target.classList.contains('search-item__remove')
        || e?.target.classList.contains('fa-list-ul')
        || e?.target.classList.contains('fa-xmark')
        || e?.target.classList.contains('fa-check')
        || e?.target.className === 'modal-content'
        || e?.target.className?.includes('change_name_cancel')
        || e?.target.className?.includes('change_name_submit')
        || e?.target.className?.includes('confirm_button')
        || e?.target.className?.includes('cancel_button')
        || document.getElementsByClassName('manage-wl-change-name-modal')[0]?.contains(e?.target)
        || (warningWrapper && warningWrapper.contains(e?.target))
      ) return;

      if (this.dropDown.current && !this.dropDown.current.contains(e?.target) && dropDownOpen) {
        const { openedSearchbarType } = this.props;
        actions.closeWatchlistDropDown();
        actions.removeSearchbarResults();
        const currentType = openedSearchbarType.find((f) => f.type === 'createWatchlistsSearchbar');
        if (currentType && currentType.opened) {
          actions.toggleSearchbar('createWatchlistsSearchbar');
        }
      }
    }, 200);
  }

  handleCloseModal() {
    setTimeout(() => {
      if (this.mounted) {
        this.setState({
          openModal: false,
        });
      }
    }, 300);
  }

  handleWLClose() {
    const { actions } = this.props;
    actions.openNewWatchlistDropDown();
    actions.removeSearchbarResults();
  }

  openRemoveAllModal() {
    this.setState(({ openModal }) => ({
      openModal: !openModal,
    }));
  }

  handleScroll() {
    if (window?.pageYOffset >= 60) {
      this.setState({ scrolled: true });
    } else {
      this.setState({ scrolled: false });
    }
  }

  render() {
    const {
      client,
      maxWatchlist,
      showIndicator,
      piwikEnabled,
      watchlists,
      activeWatchlistId,
      searchBarActive,
      promoHeight,
      width,
      isFetchingWatchlistList,
    } = this.props;
    const { openModal, scrolled } = this.state;

    const watchlistsDropdownWrapper = cx('watchlists_dropdown_wrapper', {
      fixed: scrolled,
      acive_search: searchBarActive,
    });

    // move active Watchlist on first place always before render
    // copy aray of WLs from main-global state
    const changedWl = cloneDeep(watchlists);
    // find index of activeWl
    const activeWlIndex = changedWl.findIndex((watchlist) => watchlist.id === activeWatchlistId);
    // move active Watchlist on first place if there is it in array
    if (activeWlIndex > -1) {
      changedWl.unshift(
        changedWl.splice(activeWlIndex, 1)[0],
      );
    }

    return (
      <div className={watchlistsDropdownWrapper} ref={this.dropDown}>
        <div className={Styles.dropdown_heading}>
          <h2>Watchlists</h2>
          <div onClick={this.handleWLClose}>
            <FontAwesomeIcon icon={faXmark} />
          </div>
        </div>
        <div className={Styles.new_watchlist}>
          <h2 className="mb-5">Create a new watchlist:</h2>
          <WatchlistUpdateSuggestion piwikEnabled={piwikEnabled} />
          <div
            className={cx('new_watchlist_searchbar', { active_search_bar: searchBarActive })}
            style={searchBarActive && width > 767 ? { marginTop: `${promoHeight}px` } : {}}
          >
            <SearchbarInner
              searchStyles={[
                'fixed_searchbar',
                'multiple_searchbar_fixed',
                'multiple_searchbar_fixed_watchlist_create_page',
                'multiple_slide_search_create_more_wl',
              ]}
              multipleSearch
              client={client}
              piwikEnabled={piwikEnabled}
              searchbarType="createWatchlistsSearchbar"
              disabled={changedWl.length >= maxWatchlist}
              isWatchlist
            />
          </div>
        </div>
        <div className={`${Styles.watchlists_lists_wrapper} d-flex justify-content-between`}>
          <div className={Styles.watchlists_lists}>
            <div className={`d-flex justify-content-between ${Styles.watchlist_list_header}`}>
              <h2>
                Your Watchlists&nbsp;
                {showIndicator && (
                  <span className={Styles.counter}>{`${changedWl.length} / ${maxWatchlist}`}</span>
                )}
              </h2>
              <span
                className={Styles.delete_all}
                onClick={this.openRemoveAllModal}
              >
                Delete all
              </span>
            </div>
            <ul>
              {changedWl.map((watchlist) => (
                <li key={watchlist.id}>
                  <WatchlistNameActions
                    watchlist={watchlist}
                    watchlistsArray={watchlists}
                    piwikEnabled={piwikEnabled}
                  />
                </li>
              ))}
              {isFetchingWatchlistList && (
                <li className={Styles.watchlists_lists_preloader_item}>
                  <Preloader loading static centered />
                </li>
              )}
            </ul>
          </div>
        </div>
        <RemoveAllWatchlistsModal
          openModal={openModal}
          handleCloseModal={this.handleCloseModal}
        />
      </div>
    );
  }
}

WatchlistDropDown.defaultProps = {
  client: null,
};

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators({ ...watchlistActions, ...searchActions }, dispatch),
});

const mapStateToProps = (state) => ({
  watchlists: state.watchlistReducer.watchlistsList,
  isFetchingWatchlistList: state.watchlistReducer.isFetchingWatchlistList,
  activeWatchlistId: state.watchlistReducer.activeWatchlistId,
  token: state.watchlistReducer.userToken,
  dropDownOpen: state.watchlistReducer.newWatchlistDropDown,
  maxWatchlist: state.subscriptions.permissions.max_watchlists,
  showIndicator: !state.subscriptions.permissions.access_levels.includes(SILVER),
  openedSearchbarType: state.searchReducers.openedSearchbarType,
  searchBarActive: state.searchReducers.searchBarActive,
  promoHeight: state.promobar.height,
  width: state.common.width,
});

export default withComponentName(
  connect(mapStateToProps, mapDispatchToProps)(WatchlistDropDown),
);
